module.exports = __webpack_public_path__ + "static/media/20ECE17.3d48bfa9.jpg";